import { Platform } from 'react-native';

export function QueryParams<Type>(): Type {
  if (Platform.OS !== 'web') return {} as unknown as Type;

  const urlSearchParams = new URLSearchParams(window.location.search);
  return Object.fromEntries(urlSearchParams.entries()) as unknown as Type;
}
